module.exports = __webpack_public_path__ + "static/media/headerPhoto2.2bb65020.jpeg";